<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Seçenek Türü Ekle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" :to="`/Products/${ProductID}`" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Geri</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(Product).length === 0">Hata!</b-alert>

    <template v-if="Object.keys(Product).length > 0">
      <b-alert show variant="info">Seçenek Türü Eklenen Ürün: {{ Product.Name }}</b-alert>

      <form @submit.prevent="AddExtraType">
        <b-form-group
          class="formgroup"
          :label="Enums[index]"
          v-for="(property, index) in ExtraType"
          :key="index"
        >
          <b-form-input
            type="text"
            v-model="ExtraType[index]"
            @keypress.enter.prevent="AddExtraType"
          ></b-form-input>
        </b-form-group>

        <div class="m-t-40 d-block border-top pt-3 pl-3">
          <b-btn type="submit" variant="success" size="lg">
            <i class="material-icons mifix">save</i>
            <span class="ml-1">Ekle</span>
          </b-btn>
        </div>
      </form>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Seçenek Türü"
      },
      ExtraType: {
        Name: ""
      },
      Product: {}
    };
  },
  computed: {
    ...mapState(["StoreData", "ButtonSize"]),
    ProductID() {
      return this.$route.params.ID;
    }
  },
  methods: {
    async Refresh() {
      if (this.StoreData.Products[this.ProductID])
        await this.$set(
          this,
          "Product",
          this.StoreData.Products[this.ProductID]
        );
    },
    async AddExtraType() {
      await this.$store.dispatch("AddLoading", "AddExtraType");

      await Services.Nozich.Send(
        "AddExtraType",
        {
          ProductID: this.ProductID,
          ExtraType: this.ExtraType
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "AddExtraType");

          if (Data.Status === "Success") {
            await this.$router.push(`/Products/${this.ProductID}`)
          }
        }
      );
    }
  },
  async mounted() {
    await this.Refresh();

    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
      await this.Refresh();
    });
  }
};
</script>
